import clsx from 'clsx';
import { useMemo } from 'react';
import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import styles from './styles.module.scss';
import { useOrientation } from '@/hooks';

type ShopFnbFacilitySearchModeButtonProps = BaseButtonProps & {
    title: string;
    fullWidth?: boolean;
    ref?: React.RefObject<HTMLButtonElement> | null;
};

const ShopFnbFacilitySearchModeButton = ({ ref, title, fullWidth, ...props }: ShopFnbFacilitySearchModeButtonProps) => {
    const { isHorizontal } = useOrientation();

    const className = useMemo(() => {
        return clsx(
            styles['control-button'],
            {
                [styles['control-button__active']]: props['aria-checked'],
                // [styles['control-button__full-width']]: fullWidth,
                [styles['control-button__horizontal']]: isHorizontal,
                [styles['control-button__vertical']]: !isHorizontal,
            },
            props.className
        );
    }, [props.className, props['aria-checked'], fullWidth, isHorizontal]);

    return (
        <BaseButton {...props} ref={ref} className={className}>
            <span>{title}</span>
        </BaseButton>
    );
};

export default ShopFnbFacilitySearchModeButton;
